import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { CssBaseline } from "@material-ui/core";

import { LoadingComponent } from "../components/common";
import ForgotPasswordComponent from "../components/Session/ForgotPasswordComponent";
import { ExternaUserStyles } from "./PagesStyle";

class ForgotPasswordPage extends Component {
	render() {
		const { classes, isLoading } = this.props;
		return (
			<div className={classes.root}>
				<LoadingComponent isLoading={isLoading} />
				<CssBaseline />
				<ForgotPasswordComponent />
			</div>
		);
	}
}

ForgotPasswordPage.propTypes = {
	classes: PropTypes.object.isRequired,
	isLoading: PropTypes.bool
};

const mapStateToProps = state => ({
	isLoading: state.external.isLoading
});

export default connect(
	mapStateToProps,
	null
)(withStyles(ExternaUserStyles)(ForgotPasswordPage));
